'use client';

import { useAuth } from '@/lib/auth-context';
import { AlertTriangle } from 'lucide-react';

export default function ImpersonationBanner() {
  const { impersonatingTenantId, tenant, setImpersonatingTenant } = useAuth();
  if (!impersonatingTenantId) return null;
  return (
    <div className="fixed top-0 inset-x-0 z-50 bg-[#F59E0B] text-black px-4 py-2 flex items-center justify-between text-sm font-medium">
      <div className="flex items-center gap-2">
        <AlertTriangle className="w-4 h-4" />
        <span>Viewing as: <strong>{tenant?.name || impersonatingTenantId}</strong></span>
      </div>
      <button onClick={() => setImpersonatingTenant(null)} className="underline hover:no-underline">
        Exit
      </button>
    </div>
  );
}
